import { Constants } from "../constants";

enum Env {
  dev = "development",
  qa = "qa",
  staging = "staging",
  production = "production",
}

export const getApiBasePath = (): string => {
  const environment = process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV;
  switch (environment) {
    case Env.qa:
      return Constants.API_QA_BASE_PATH;
    case Env.staging:
      return Constants.API_STAGING_BASE_PATH;
    case Env.production:
      return Constants.API_PROD_BASE_PATH;
    case Env.dev:
    default:
      return Constants.API_QA_BASE_PATH;
  }
};

export const getShServiceBasePath = (): string => {
  const environment = process.env.REACT_APP_ENVIRONMENT ?? process.env.NODE_ENV;
  switch (environment) {
    case Env.qa:
      return Constants.SHSERVICE_QA_BASE_PATH;
    case Env.staging:
      return Constants.SHSERVICE_STAGING_BASE_PATH;
    case Env.production:
      return Constants.SHSERVICE_PROD_BASE_PATH;
    case Env.dev:
    default:
      return Constants.SHSERVICE_QA_BASE_PATH;
  }
};

export const getUserAgent = () => navigator.userAgent.toLowerCase()
export const isIphone = (): boolean => getUserAgent().includes("iphone");